<template>
  <div class="home">
    <Room artistID='ck' loadImmediate="true"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Room from '@/components/Room';

export default {
  name: "CocoKlockner",
  components: {
    Room
  },

  methods : {

    init() {
      console.log('COCO KLOCKNER')
      this.$store.commit('setArtist', this.selected);
      this.$store.commit('hide', 'gallery');
      this.$store.commit('show', 'room');
    }
  }
};
</script>
